export type Rgb = [number, number, number];

export function hexToRgb(hex: string): Rgb {
  const digits = hex.replace('#', '');
  return [0, 2, 4].map((offset) => parseInt(digits.slice(offset, offset + 2), 16)) as Rgb;
}

export function rgbToHex(rgb: Rgb): string {
  return `#${rgb.map((channel) => Math.round(channel).toString(16).padStart(2, '0')).join('')}`;
}

// Matches CSS color-mix(in srgb, <colour> N%, white), so exported values equal what the browser paints.
export function tintHex(hex: string, percent: number): string {
  return rgbToHex(hexToRgb(hex).map((channel) => 255 - (percent / 100) * (255 - channel)) as Rgb);
}

// Matches CSS color-mix(in srgb, <colour> N%, black).
export function shadeHex(hex: string, percent: number): string {
  return rgbToHex(hexToRgb(hex).map((channel) => (percent / 100) * channel) as Rgb);
}

export function relativeLuminance(hex: string): number {
  const [r, g, b] = hexToRgb(hex).map((channel) => {
    const value = channel / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(first: string, second: string): number {
  const [lighter, darker] = [relativeLuminance(first), relativeLuminance(second)].sort((a, b) => b - a);
  return (lighter + 0.05) / (darker + 0.05);
}
